import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Layout from "@/components/Layout";
import { ResultView } from "@/components/Results";
import { api } from "@/lib/api";

export default function AnalysisDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [analysis, setAnalysis] = useState(null);

  useEffect(() => {
    api.get(`/analyses/${id}`).then((r) => {
      const a = r.data;
      // Psych profiles have their own rich page — never show them as raw analysis JSON.
      if (a?.vertical === "psych_profile" && a?.relationship_id) {
        navigate(`/profile/${a.relationship_id}${a.target === "me" ? "?target=me" : ""}`, { replace: true });
        return;
      }
      setAnalysis(a);
    }).catch(() => navigate("/app"));
  }, [id, navigate]);

  const isMonitor = analysis?.source === "whatsapp_monitor";

  return (
    <Layout>
      <button
        data-testid="back-button"
        onClick={() => navigate("/app")}
        className="flex items-center gap-1 text-sm text-zinc-400 hover:text-white mb-4"
      >
        <ArrowLeft size={16} /> Retour
      </button>
      {analysis && (
        <ResultView
          vertical={analysis.vertical}
          result={analysis.result}
          messageCount={isMonitor ? (analysis.message_count ?? 0) : undefined}
          onImport={isMonitor ? () => navigate("/import") : undefined}
        />
      )}
    </Layout>
  );
}
